import { SERVER_DATE_FORMAT } from '../constants';
import type { IForm } from '../types';

const enhanceFormData = (rawData: IForm) => {
    return {
        email: rawData.email,
        balanceCurrencyCode: rawData.currency,
        dateFilter: {
            dateFrom: rawData.date[0].format(SERVER_DATE_FORMAT),
            dateTo: rawData.date[1].format(SERVER_DATE_FORMAT),
        },
    };
};

export { enhanceFormData };
